import React, { useState } from 'react';
import { Box, Typography, alpha } from '@mui/material';
import { ContentCopy as CopyIcon, Check as CheckIcon } from '@mui/icons-material';
import { ACCENT, TEXT_PRIMARY, TEXT_SECONDARY } from './SaaSTokens';
import { useTheme } from '@mui/material/styles';

const InfoField = ({ icon, label, value, copyable = false }) => {
  const [copied, setCopied] = useState(false);
  const theme = useTheme();

  const handleCopy = () => {
    if (!copyable || !value) return;
    navigator.clipboard
      .writeText(String(value))
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => {});
  };

  return (
    <Box
      onClick={handleCopy}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        p: { xs: 1.5, sm: 2 },
        borderRadius: '12px',
        border: `1px solid ${alpha(ACCENT, 0.15)}`,
        bgcolor: alpha('#fff', 0.03),
        cursor: copyable && value ? 'pointer' : 'default',
        transition: 'background 0.18s ease, border-color 0.18s ease',
        '&:hover': copyable && value ? { bgcolor: alpha(ACCENT, 0.06), borderColor: alpha(ACCENT, 0.25) } : {},
        userSelect: 'none',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          borderRadius: '10px',
          flexShrink: 0,
          background: alpha(ACCENT, 0.08),
          border: `1px solid ${alpha(ACCENT, 0.18)}`,
          color: ACCENT,
        }}
      >
        {icon}
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.3, color: TEXT_SECONDARY, mb: 0.5 }}>
          {label}
        </Typography>
        <Typography sx={{ fontSize: 14, fontWeight: 500, color: value ? TEXT_PRIMARY : alpha(TEXT_SECONDARY, 0.55), lineHeight: 1.35, wordBreak: 'break-word' }}>
          {value || '—'}
        </Typography>
      </Box>

      {copyable ? (
        <Box sx={{ alignSelf: 'center', flexShrink: 0, opacity: 0.75 }}>
          {copied ? <CheckIcon sx={{ fontSize: 16, color: alpha(ACCENT, 1) }} /> : <CopyIcon sx={{ fontSize: 16, color: alpha(TEXT_SECONDARY, 0.7) }} />}
        </Box>
      ) : null}
    </Box>
  );
};

export default InfoField;

